<template>
  <BSidebar
    type="is-white"
    :fullheight="true"
    :fullwidth="false"
    :right="true"
    :open="showAdvanceFilter"
    :can-cancel="false"
    overlay
    mobile="fullwidth"
    position="fixed"
    @close="toggleAdvanceFilter"
  >
    <section class="custom-section">
      <div class="custom-section__teams">
        <div class="custom-section__teams__team">
          <img :src="homeTeam.logo" alt="Local Team Logo" />
          <span class="custom-section__teams__team__name">{{ homeTeam.colloquial_name }}</span>
        </div>
        <div class="custom-section__teams__team">
          <span class="custom-section__teams__team__name">{{ visitingTeam.colloquial_name }}</span>
          <img :src="visitingTeam.logo" alt="Visit Team Logo" />
        </div>
      </div>
      <div class="custom-section__options">
        <div>
          <!-- Aqui va el local -->
          <AdvancedFilterOptions v-model="filter.local" />
        </div>
        <div>
          <!-- Aqui va el visitante -->
          <AdvancedFilterOptions v-model="filter.visit" is-away-team />
        </div>
      </div>
      <div class="custom-section__actions">
        <hr />
        <div class="custom-section__actions__buttons">
          <div class="custom-section__actions__buttons__button close" role="button" @click="onCloseClicked">Cerrar</div>
          <div class="custom-section__actions__buttons__button apply" role="button" @click="onClickApplyFilter">
            Aplicar filtros
          </div>
        </div>
      </div>
    </section>
  </BSidebar>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { clickBtnAplicarFiltros } from '@/utils/analytics';
let filterAux = null;
export default {
  name: 'AdvanceFilter',
  components: {
    AdvancedFilterOptions: () => import('@/components/Elements/NextMatches/AdvancedFilterOptions'),
    BSidebar: async () => {
      const { BSidebar } = await import('buefy/dist/esm/sidebar');
      return BSidebar;
    },
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filter: this.getObjectInitialFilter(),
      isAppling: false,
    };
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.fillFiltersValues();
        }
      },
    },
    statisticsTypes: {
      immediate: true,
      handler(newValue) {
        this.filter.local.statistics = newValue[0] || 0;
        this.filter.visit.statistics = newValue[0] || 0;
        this.updateFilters({ filters: this.filter, needsFormat: true });
        this.updateRankingInSubcategories();
      },
    },
    showAdvanceFilter(newValue) {
      if (newValue) {
        filterAux = {
          local: this.cloneFilterOptions(this.filter.local),
          visit: this.cloneFilterOptions(this.filter.visit),
        };
      }
      this.isAppling = false;
    },
    'filter.local.statistics'(newValue, oldValue) {
      if (!newValue) {
        this.filter.local.statistics = {
          parentAnalysis: [1, 2, 3],
          value: 0,
          text: 'Realizado',
          block: 1,
        };
      } else if (!oldValue || newValue.block !== oldValue.block) {
        this.filter.visit.statistics = newValue;
      }
    },
    'filter.visit.statistics'(newValue, oldValue) {
      if (!newValue) {
        this.filter.visit.statistics = {
          parentAnalysis: [1, 2, 3],
          value: 0,
          text: 'Realizado',
          block: 1,
        };
      } else if (!oldValue || newValue.block !== oldValue.block) {
        this.filter.local.statistics = newValue;
      }
    },
    showPostMatchData() {
      this.setPostMatchFilters();
    },
    gameForAnalysis(newValue) {
      this.filter = this.getObjectInitialFilter();
      if (newValue.game_status === 1) {
        this.setPostMatchFilters();
      } else {
        this.updateFilters({
          filters: this.filter,
          needsFormat: true,
        });
      }
    },
  },
  computed: {
    ...mapGetters('nextGeneral', [
      'showAdvanceFilter',
      'homeTeam',
      'visitingTeam',
      'statisticsTypes',
      'gameId',
      'showPostMatchData',
      'getHomeResultGame',
      'getAwayResultGame',
    ]),
    ...mapGetters('loginGeneral', ['getPremiumAccount', 'isLoggedIn', 'getIsGolstats']),
    ...mapGetters('general', ['getPreviewSectionAnalytics']),
    ...mapState('nextGeneral', ['gameForAnalysis']),
    isMobile() {
      return this.$mq === 'mobile';
    },
  },
  mounted() {
    this.filters = this.storeFilters;
  },
  methods: {
    ...mapMutations('nextGeneral', ['toggleAdvanceFilter', 'updateFilters']),
    ...mapMutations('general', ['setSectionAnalytics']),
    ...mapActions('nextGeneral', ['updateRankingInSubcategories']),
    ...mapActions('alertGeneral', ['setAlert']),
    ...mapMutations(['SET_PREMIUM_MESSAGE']),
    ...mapMutations(['SET_AUTH_COMPONENT']),
    setPostMatchFilters() {
      // if (this.getPremiumAccount) {
      if (this.showPostMatchData) {
        this.filter.local.playingAs.splice(1, 1);
        this.filter.visit.playingAs.splice(0, 1);
        if (this.getHomeResultGame > this.getAwayResultGame) {
          this.filter.local.matchResult.splice(2, 1);
          this.filter.local.matchResult.splice(1, 1);
          this.filter.visit.matchResult.splice(0, 1);
          this.filter.visit.matchResult.splice(1, 1);
        } else {
          if (this.getHomeResultGame < this.getAwayResultGame) {
            this.filter.local.matchResult.splice(2, 1);
            this.filter.local.matchResult.splice(0, 1);
            this.filter.visit.matchResult.splice(2, 1);
            this.filter.visit.matchResult.splice(1, 1);
          } else {
            this.filter.local.matchResult.splice(1, 1);
            this.filter.local.matchResult.splice(0, 1);
            this.filter.visit.matchResult.splice(1, 1);
            this.filter.visit.matchResult.splice(0, 1);
          }
        }
        this.updateFilters({
          filters: this.filter,
          needsFormat: true,
        });
      }
      // }
    },
    getObjectInitialFilter() {
      return {
        local: {
          playingAs: [1, 2],
          statistics: {},
          matchResult: [1, 2, 3],
          firstHalf: [1, 2, 3],
          secondHalf: [4, 5, 6],
        },
        visit: {
          playingAs: [1, 2],
          statistics: {},
          matchResult: [1, 2, 3],
          firstHalf: [1, 2, 3],
          secondHalf: [4, 5, 6],
        },
      };
    },
    fillFiltersValues() {
      if (this.showPostMatchData) {
        this.filter.local.playingAs.splice(1, 1);
        this.filter.visit.playingAs.splice(0, 1);
        if (this.getHomeResultGame > this.getAwayResultGame) {
          this.filter.local.matchResult.splice(2, 1);
          this.filter.local.matchResult.splice(1, 1);
          this.filter.visit.matchResult.splice(0, 1);
          this.filter.visit.matchResult.splice(1, 1);
        } else {
          if (this.getHomeResultGame < this.getAwayResultGame) {
            this.filter.local.matchResult.splice(2, 1);
            this.filter.local.matchResult.splice(0, 1);
            this.filter.visit.matchResult.splice(2, 1);
            this.filter.visit.matchResult.splice(1, 1);
          } else {
            this.filter.local.matchResult.splice(1, 1);
            this.filter.local.matchResult.splice(0, 1);
            this.filter.visit.matchResult.splice(1, 1);
            this.filter.visit.matchResult.splice(0, 1);
          }
        }
      }
    },
    storeFilters() {
      return this.$store.state.filters;
    },
    onClickApplyFilter() {
      clickBtnAplicarFiltros(this.getPremiumAccount, this.gameId, this.getPreviewSectionAnalytics, this.getIsGolstats);
      // if (this.getPremiumAccount) {
      this.isAppling = true;
      setTimeout(() => {
        this.updateFilters({ filters: this.filter, needsFormat: true });
        this.toggleAdvanceFilter();
        this.updateRankingInSubcategories();
      }, 1);
      // } else {
      //   this.onCloseClicked();
      //   this.setSectionAnalytics('Popup_AF_OP');
      //   this.SET_PREMIUM_MESSAGE(true);
      // }
    },
    onCloseClicked() {
      if (filterAux) {
        this.filter = {
          local: this.cloneFilterOptions(filterAux.local),
          visit: this.cloneFilterOptions(filterAux.visit),
        };
      }
      this.toggleAdvanceFilter();
    },
    cloneFilterOptions(filterOptions) {
      return {
        playingAs: [...filterOptions.playingAs],
        statistics: filterOptions.statistics,
        matchResult: [...filterOptions.matchResult],
        firstHalf: [...filterOptions.firstHalf],
        secondHalf: [...filterOptions.secondHalf],
      };
    },
  },
};
</script>
<style scoped lang="scss">
.custom-section {
  font-size: 1rem;
  padding: 3em 0.625em 3em;
  &__teams {
    display: flex;
    justify-content: space-between;
    border-radius: 11px;
    border: solid 1px #e9e9e9;
    margin-bottom: 2em;

    &__team {
      display: flex;
      align-items: center;

      &__name {
        font-family: Avenir-Demi, sans-serif;
        font-size: 25px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.72;
        letter-spacing: -0.5px;
        text-align: center;
        color: #132739;
      }

      & > img {
        height: 72px;
        width: 72px;
        margin: 1em;
      }
    }

    @media screen and (max-width: 510px) {
      justify-content: space-around;
      padding-bottom: 1em;

      &__team {
        flex-direction: column;
        align-items: center;

        &__name {
          font-size: 20px;
        }

        & > img {
          height: 52px;
          width: 52px;
        }

        &:last-child {
          flex-direction: column-reverse;
        }
      }
    }
  }

  &__options {
    display: flex;
    justify-content: space-between;
    padding: 0 2em;
  }

  &__actions {
    width: 100%;
    padding: 0 2em;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 3em;

    &__buttons {
      width: 100%;
      margin-top: 3.5em;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 1em;

      &__button {
        width: 100%;
        cursor: pointer;
        font-family: Avenir-Demi, sans-serif;
        font-size: 1em;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.06;
        letter-spacing: -0.16px;
        text-align: center;
        color: #132739;
        padding: 0.9em 0 0.7em;
        border-radius: 6px;

        &.close {
          border: solid 1px #132739;
        }

        &.apply {
          border: solid 2px #2986d8;
          background-color: #2986d8;
          color: white;
        }
      }
    }

    & > hr {
      width: 100%;
      border-top: dotted 1px #b6c0c7;
      margin: 1em;
    }
  }

  @media screen and (max-width: 450px) {
    &__options {
      padding: 0 0.5em;
    }

    &__actions {
      padding: 0 0.5em;
      margin-top: 1em;

      &__buttons {
        margin-top: 1.5em;
      }
    }
  }

  @media screen and (max-width: 400px) {
    &__options {
      padding: 0 0.5em;
    }

    &__actions {
      padding: 0 0.5em;

      &__buttons {
        &__button {
          font-size: 1em;
        }
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .custom-section {
    padding: 1.5rem 0.5em 1.5rem 0.5em;
    width: 100%;
  }
}
</style>

<style lang="scss">
.b-sidebar {
  & .sidebar-background {
    z-index: 1002 !important;
  }
  & .sidebar-content {
    width: 550px !important;
    z-index: 1003 !important;
  }
}
</style>
